<template>
  <div class="page-template add-page order-add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button
        @click="refresh"
        type="primary"
        plain
        v-show="formModel.reviewerStatus !== 10"
        >刷新
      </el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button
        @click="audit(3)"
        type="primary"
        plain
        :disabled="formModel.reviewerStatus === null"
        >审核
      </el-button>
      <el-button @click="complexFunc" type="primary" plain
        >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form
      v-show="complexShow"
      ref="listOperationForm"
      :formOptions="listFormOptions"
      @valueChange="listFormValueChange"
    >
    </list-operation-form>
    <div class="search-goods-box">
      <el-input
        id="goodsText"
        ref="goodsInput"
        placeholder="条码/自编码/助记码"
        v-model="goodsTxt"
        class="search-goods-input"
        @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good"
        >选择商品
      </el-button>
      <!--      <el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="800"
      :close-on-click-modal="false"
    >
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        :otherParam="otherParam"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog
      title="导入"
      :visible.sync="importShow"
      custom-class="importDialog"
      :close-on-click-modal="false"
    >
      <import-template
        v-if="importShow"
        ref="importTemplate"
        :importShow="importShow"
        @importFile="importData"
        @downTemplate="downloadTemplate"
      ></import-template>
    </el-dialog>
  </div>
</template>
<script>
  // 商品列表组件
  import goodList from "@/components/business/goodList";
  // 表单单组件
  import listOperationNew from "@/components/template/listOperationNew";
  // 搜索组件
  import listOperationForm from "@/components/template/listOperationForm";
  // 导入模版组件
  import importTemplate from "@/components/business/importTemplate";
  import api from "@/config/api";
  // 数据权限
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        // 导入
        importShow: false,
        isCheck: false,
        moreShow: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [],
        goodListSelect: false,
        loading: false,
        title: "",
        listShow: false,
        goodList: [],
        formModel: {
          reviewerStatus: null
        },
        dialogShow: false,
        isSelectSupplier: true,
        isSelectWarehouse: true,
        isClearTableData: true,
        otherParam: {statusList: [10, 20], isOpenCombination: 2},
        selectUrl: {url: api.warehouse.warehouseGoods},
        // 头部条件
        listFormOptions: {
          statusOption: {
            prop: "reviewerStatus",
            statusImg: {
              10: "/static/checked.png",
              20: "/static/un-check.png"
            }
          },
          labelWidth: "130px",
          columns: [
            {
              prop: "id",
              hidden: true
            },
            {
              label: "业务单号",
              type: "input",
              prop: "orderNo",
              span: 8,
              disabled: true
            },
            {
              label: "采购门店",
              type: "storeInputDialog",
              prop: "storeId",
              span: 8,
              disabled: false,
              isHasAll: true, // 下拉选择添加‘总部’字段
              change: this.purchaseStoreChange
            },
            {
              label: "供应商",
              type: "supplierInputDialog",
              prop: "supplierId",
              span: 8,
              disabled: false,
              change: this.supplierChange,
              isEditSupplier: false,
              param: {type: 10}
            },
            {
              label: "仓库",
              type: "warehouseInputDialog",
              prop: "warehouseId",
              disabled: false,
              change: this.warehouseChange,
              span: 8
            },
            {
              label: "经手人",
              prop: "handler",
              type: "input",
              disabled: false,
              span: 8
            },
            {
              label: "备注",
              type: "input",
              maxLength: 16,
              prop: "remarks",
              span: 8
            }
          ]
        },
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: [
            "goodsNum",
            "salesAmount",
            "totalPrice",
            "giveGoodsNum"
          ],
          columns: [
            {
              label: "操作",
              code: "delete",
              type: "operation",
              width: "80"
            },
            {label: "序号", type: "index", width: 60, prop: "idx"},
            {
              label: "条码",
              prop: "barCode",
              width: "150",
              blur: this.getInfo
            },
            {
              label: "商品名称",
              prop: "goodsName",
              width: "90"
            },
            {
              label: "规格",
              prop: "specs",
              width: "60"
            },
            {
              label: "单位",
              width: "60",
              prop: "unitName"
            },
            {
              label: "自编码",
              width: "90",
              prop: "artNo"
            },
            // {
            //   label: '档案进价',
            //   width: '90',
            //   prop: 'buyPrice',
            // },
            {
              label: "数量",
              width: "120",
              prop: "goodsNum",
              type: "inputNumber",
              // max: 9999.999,
              change: this.numChange,
              precision: 3
            },
            {
              label: "赠送数量",
              width: "90",
              prop: "giveGoodsNum",
              change: this.giveGoodsNumChange,
              type: "inputNumber",
              max: 9999.999,
              precision: 3
            },
            {
              label: "进价",
              width: "90",
              prop: "price",
              type: "inputNumber",
              change: this.priceChange,
              precision: 3
            },
            {
              label: "小计金额",
              width: "160",
              prop: "totalPrice",
              type: "inputNumber",
              change: this.totalPriceChange,
              precision: 3
            },
            {
              label: "零售价",
              width: "100",
              prop: "retailPrice"
            },
            {
              label: "零售金额",
              width: "90",
              prop: "salesAmount"
            },
            {
              label: "系统库存",
              width: "90",
              prop: "inventoryNum"
            },
            {
              label: "备注",
              type: "input",
              maxLength: 16,
              prop: "remarks",
              width: "200"
            }
          ]
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true, // 是否显示索引
          indexMethod: index => {
            // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: "条码",
              prop: "barCode",
              width: "210",
              align: "center"
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "150",
              align: "center"
            },
            {
              label: "规格",
              prop: "specs",
              width: "80",
              align: "center"
            },
            {
              label: "单位",
              prop: "unitName",
              width: "80",
              align: "center"
            },
            {
              label: "进货价",
              prop: "buyPrice",
              width: "150",
              align: "center"
            },
            {
              label: "零售价",
              prop: "retailPrice",
              width: "150",
              align: "center"
            },
            {
              label: "库存",
              prop: "inventoryNum",
              width: "150",
              align: "center"
            }
          ],
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: "",
        supplierInfo: {},
        settingInfo: {}
      };
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200;
    },
    created() {
      this.title = (this.$route.query.id ? "编辑" : "新增") + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        this.$nextTick(() => {
          this.$refs.listOperationForm.formModel.warehouseId = this.$utils.getSysUser().warehouseId;
          this.isSelectWarehouse = false;
        })
      }
      this.getSettingStatus();
      this.setStoreId(this.listFormOptions.columns);
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop == "storeId") {
          this.listFormOptions.columns.filter(
            item => item.prop === "supplierId"
          )[0].params = {storeId: value.id};
          this.listFormOptions.columns.filter(
            item => item.prop === "warehouseId"
          )[0].params = {storeId: value.id};
        }

        if (column.prop == "storeId") {
          this.otherParam.storeId = value.id;
          //门店修改后清空仓库和供应商
          this.$refs.listOperationForm.$refs.supplierInputDialog[0].initData();
          // this.$refs.listOperationForm.$refs.warehouseInputDialog[0].initData();
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          if (value.warehouseId) {
            this.$refs.listOperationForm.formModel.warehouseId = value.warehouseId;
            this.otherParam.warehouseId = value.warehouseId;
            this.isSelectWarehouse = false;
          }
        } else if (column.prop == "supplierId") {
          this.otherParam.supplierId = value;
          this.isSelectSupplier = false;
        } else if (column.prop == "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
        }
        this.$refs['listOperation'].clearTableData();
      },
      // 获取设置状态
      getSettingStatus(val) {
        // 获取设置信息 接口
        this.$axios
          .fetchGet(api.purchase.pcPurchaseDefaultInfo, {})
          .then(res => {
            if (res.code === 200) {
              if (res.data) {
                this.settingInfo = res.data;
              }
            } else {
              this.$message({type: "error", message: res.msg});
            }
          })
          .catch(err => {
          });
      },
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.purchase.order + "?id=" + this.$route.query.id, {})
          .then(data => {
            this.formModel = data.data;
            this.loading = false;
            if (data.code === 200) {
              this.$nextTick(() => {
                // 为头部表单赋值
                this.supplierInfo.storeId = data.data.storeId; // 门店id
                this.otherParam.storeId = data.data.storeId; // 门店id,barcode查询需要的参数
                this.$refs.listOperationForm.formModel = data.data;
                this.isSelectWarehouse = false;
                this.isSelectSupplier = false;
                this.isClearTableData = false;
                // 为头部表单赋值
                // this.$refs.listOperationForm.formModel.storeId = data.data.storeId;
                // 为表格赋值
                this.$refs["listOperation"].addMoreRow(
                  data.data.pcGoodsMapList,
                  0
                );
                this.currentTableList = this.$refs[
                  "listOperation"
                  ].getTabelData();
                this.listFormOptions.columns.filter(
                  item => item.prop === "storeId"
                )[0].disabled = true;
                this.listFormOptions.columns.filter(
                  item => item.prop === "supplierId"
                )[0].disabled = true;
                this.listFormOptions.columns.filter(
                  item => item.prop === "warehouseId"
                )[0].disabled = true;
                this.listFormOptions.columns.filter(
                  item => item.prop === "handler"
                )[0].disabled = true;
              });
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch(err => {
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },
      clearData() {
        this.$nextTick(() => {
          this.isSelectSupplier = true;
          this.isSelectWarehouse = true;
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.warehouseId = "";
        });
      },
      getSupplierAndWarehouse(param) {
        this.otherParam.storeId = param.storeId;
        let supplierId = this.listFormOptions.columns.filter(
          item => item.prop === "supplierId"
        )[0];
        this.$axios
          .fetchPost(api.archives.supplier + "/list", {
            storeId: param.storeId,
            type: 10
          })
          .then(data => {
            if (data.code === 200) {
              this.$refs.listOperationForm.formModel.supplierId = "";
              supplierId.data = data.data;
            }
          });
        this.$axios
          .fetchPost(api.warehouse.warehouse + "/list", {
            storeId: param.storeId
          })
          .then(data => {
            if (data.code === 200) {
              if (data.data && data.data.length > 0) {
                this.listFormOptions.columns.filter(
                  item => item.prop === "warehouseId"
                )[0].data = data.data;
                data.data.map(item => {
                  if (item.defaultState === true) {
                    this.$refs.listOperationForm.formModel.warehouseId = item.id;
                    this.isSelectWarehouse = false;
                    this.supplierInfo.warehouseId = item.id;
                  }
                });
              } else {
                this.listFormOptions.columns.filter(
                  item => item.prop === "warehouseId"
                )[0].data = [];
                this.$refs.listOperationForm.formModel.warehouseId = "";
                this.isSelectWarehouse = true;
                this.supplierInfo.warehouseId = "";
              }
            }
          });
      },
      search() {
        if (this.goodsTxt === "" || this.goodsTxt === null) return;
        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        if (this.isSelectSupplier) {
          this.goodsTxt = "";
          this.$confirm("请选择供应商！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          if (this.isSelectWarehouse) {
            this.goodsTxt = "";
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
          } else {
            this.otherParam.otherName = this.goodsTxt;
            this.otherParam = {...this.otherParam, ...this.supplierInfo};
            this.isCheck = true;
            this.$axios
              .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
              .then(res => {
                if (res.code === 200) {
                  if (res.data.length > 0) {
                    let tableData = res.data;
                    if (tableData.length === 1) {
                      let row = tableData[0];
                      let tableList = this.$refs["listOperation"].getTabelData();
                      let flag = true;
                      if (tableList.length > 0) {
                        tableList.forEach(item => {
                          if (flag) {
                            if (item.barCode === row.barCode) flag = false;
                          }
                        });
                      }
                      if (!flag) {
                        this.$message.warning(
                          "[名称:" +
                          row.goodsName +
                          ",条码:" +
                          row.barCode +
                          "],已存在！！！"
                        );
                        return;
                      }
                      row.salesAmount = (0.0).toFixed(2); // 销售金额
                      row.goodsNum = (0.0).toFixed(3); // 数量
                      row.giveGoodsNum = (0.0).toFixed(3); // 赠送数量
                      row.price = row.buyPrice;
                      row.totalPrice = (0.0).toFixed(2);
                      row.remarks = null;
                      // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                      this.$refs["listOperation"].setColumnData(
                        row,
                        tableList.length
                      );
                      this.currentTableList = this.$refs[
                        "listOperation"
                        ].getTabelData();
                      this.$message.success("商品添加成功");
                    } else {
                      this.queryGoodsList();
                    }
                  } else {
                    this.$message.warning(
                      "[条码:" + this.goodsTxt + "],商品不存在！！！"
                    );
                  }
                } else {
                  this.$message({type: "error", message: res.msg});
                }
              })
              .catch(err => {
              })
              .finally(() => {
                this.isCheck = false;
                this.clearQueryParam();
              });
          }
        }
      },
      clearQueryParam() {
        this.goodsTxt = "";
        this.otherParam.otherName = "";
      },
      checkGoods() {
        if (!this.isCheck) {
          if (this.isSelectSupplier) {
            this.$confirm("请选择供应商！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
          } else {
            if (this.isSelectWarehouse) {
              this.$confirm("请选择仓库！", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              });
            } else {
              this.queryGoodsList();
            }
          }
        }
      },
      queryGoodsList() {
        this.listShow = true;
        this.goodListSelect = true;
        this.listTableData = this.$refs["listOperation"].getTabelData(); // table数据  原始的

        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        this.otherParam = {...this.otherParam, ...this.supplierInfo};
      },

      supplierChange(data) {
        if (data.supplierId) {
          this.isSelectSupplier = false;
          this.$refs["listOperation"].clearTableData();
          this.supplierInfo.supplierId = data.supplierId;
        } else {
          this.isSelectSupplier = true;
        }
      },
      //  多选择商品 确认
      rowsSelectSubmit(row) {
        row.map(item => {
          // 商品多选的时候进行相应数据初始化
          item.salesAmount = (0.0).toFixed(2); // 销售金额
          item.goodsNum = (0.0).toFixed(3); // 数量
          item.giveGoodsNum = (0.0).toFixed(3); // 赠送数量
          item.price = item.buyPrice;
          item.totalPrice = (0.0).toFixed(2);
          item.remarks = null;
        });
        this.listShow = false;
        let tableList = this.$refs["listOperation"].getTabelData();
        this.$refs["listOperation"].addMoreRow(row, tableList.length);
        this.currentTableList = this.$refs["listOperation"].getTabelData();
        if (row && row.length > 0) {
          this.$message.success("商品添加成功");
        }
      },
      numChange(row, index) {
        if (row.goodsNum && row.goodsNum >= 9999.999) {
          row.goodsNum = "9999.999".toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.goodsNum === "" || row.goodsNum == null) {
          row.goodsNum = rowData.goodsNum.toString();
          row.price = rowData.price.toString();
          row.totalPrice = rowData.totalPrice.toString();
          row.salesAmount = rowData.salesAmount.toString();
        }
        if (row.retailPrice) {
          row.salesAmount = parseFloat(row.retailPrice * row.goodsNum).toFixed(2);
        }
        if (row.price) {
          row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
        }
        this.$refs["listOperation"].setCountData(row, index);
      },
      giveGoodsNumChange(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.giveGoodsNum === "" || row.giveGoodsNum == null) {
          row.giveGoodsNum = rowData.giveGoodsNum.toString();
        }
        this.$refs["listOperation"].setCountData(row, index);
      },
      // 输入商品价格
      priceChange(row, index) {
        if (row.price && row.price >= 99999.999) {
          row.price = "99999.999".toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.price == null || row.price === "") {
          row.price = rowData.price.toString();
        }
        if (row.price.toString() && row.buyPrice) {
          if (
            Number(row.price) > Number(row.buyPrice) &&
            this.settingInfo.greaterGoodsPrice
          ) {
            this.$confirm("当前进价大于商品档案进价，确认？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
                this.$refs["listOperation"].setCountData(row, index);
              })
              .catch(() => {
                row.price = rowData.price;
              });
          } else {
            row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
            this.$refs["listOperation"].setCountData(row, index);
          }
        }
      },
      totalPriceChange(row, index) {
        if (row.totalPrice && row.totalPrice >= 99999.999) {
          row.totalPrice = "99999.999".toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (
          row.totalPrice !== null &&
          row.totalPrice !== "" &&
          row.totalPrice !== undefined
        ) {
          if (
            row.goodsNum !== null &&
            row.goodsNum !== "" &&
            row.goodsNum !== 0
          ) {
            row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
            if (row.price.toString() && rowData.buyPrice) {
              if (
                Number(row.price) > Number(row.buyPrice) &&
                this.settingInfo.greaterGoodsPrice
              ) {
                this.$confirm("当前进价大于商品档案进价，确认？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                    row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(
                      2
                    );
                  })
                  .catch(() => {
                    row.price = rowData.price;
                  });
              } else {
                row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
              }
            }
          } else {
            row.totalPrice = rowData.totalPrice.toString();
          }
        } else {
          if (
            (row.totalPrice == null ||
              row.totalPrice === "" ||
              row.totalPrice === undefined) &&
            (row.goodsNum === null || row.goodsNum === "" || row.goodsNum === 0)
          ) {
            row.goodsNum = rowData.goodsNum.toString();
            row.price = rowData.price.toString();
            row.totalPrice = rowData.totalPrice.toString();
          } else {
            row.totalPrice = rowData.totalPrice.toString();
            row.price = "0.00";
          }
        }
        this.$refs["listOperation"].setCountData(row, index);
      },
      // 选择某行数据
      rowCheck(row) {
        row.salesAmount = (0.0).toFixed(2); // 销售金额
        row.goodsNum = (0.0).toFixed(3); // 数量
        row.giveGoodsNum = (0.0).toFixed(3); // 赠送数量
        row.price = row.buyPrice;
        row.totalPrice = (0.0).toFixed(2);
        // item.remarks = null;
        row.remarks = null;
        this.listShow = false;
        this.$refs["listOperation"].setColumnData(row, this.checkIndex);
        this.currentTableList = this.$refs["listOperation"].getTabelData();
      },
      // 获取某行数据填充
      getInfo(rowData, index) {
        if (this.isSelectSupplier) {
          this.$confirm("请选择供应商！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          if (this.isSelectWarehouse) {
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
          } else {
            if (rowData.barCode) {
              // 通过货号获取商品信息
              this.queryGoodsByBarCode(rowData.barCode, index);
            } else {
              this.goodListSelect = false;
              this.listShow = true;
              this.listTableData = this.$refs["listOperation"].getTabelData(); // table数据
              this.currentTableList = this.$refs["listOperation"].getTabelData();
              if (!this.settingInfo.supplierGoods) {
                this.supplierInfo.supplierId = "";
              }
              this.checkIndex = index;
              this.$nextTick(() => {
                this.otherParam = {...this.otherParam, ...this.supplierInfo};
              });
            }
          }
        }
      },
      // 返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },
      audit(e) {
        if (!this.isCheck) {
          this.submitAuth(e);
        }
      },
      valideMount(val) {
        const mountArray = ["giveGoodsNum", "goodsNum", "inventoryNum"];
        if (mountArray.includes(val)) {
          return true;
        } else {
          return false;
        }
      },
      validePirce(val) {
        const priceArray = [
          "buyPrice",
          "deliveryPrice",
          "lowestPrice",
          "plusVipPrice",
          "retailPrice",
          "tradePrice",
          "vipPrice"
        ];
        if (priceArray.includes(val)) {
          return true;
        } else {
          return false;
        }
      },
      // 提交数据
      submitAuth(e) {
        if (!this.isCheck) {
          // 将商品list的值重新赋值给后端接收的参数
          let tableList = this.$refs["listOperation"].getTabelData();
          let orderNumber = 1;
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            item.goodsId = item.goodsId || item.id;
            item.type = 10;
            item.id = null;
          });
          // 将合计的值重新赋值给后端接收的参数
          let totalParam = this.$refs["listOperation"].getSumData();
          totalParam.orderAmt = totalParam.totalPrice;
          // 将表头的值重新赋值给后端接收的参数
          let headParam = this.$refs.listOperationForm.getFormModel();
          headParam.reviewerStatus = 20;
          let searchParam = {
            ...{pcGoodsMapList: tableList},
            ...totalParam,
            ...headParam
          };
          if (tableList.length == 0) {
            this.$message({message: "商品信息无效！", type: "warning"});
          } else {
            let priceFlag = false;
            let mountFlag = false;
            tableList.map(item => {
              for (let key in item) {
                if (this.validePirce(key)) {
                  if (item[key] > 99999.99) {
                    priceFlag = true;
                  }
                }
                if (this.valideMount(key)) {
                  if (item[key] > 9999.999) {
                    mountFlag = true;
                  }
                }
              }
            });
            if (mountFlag)
              return this.$message.warning("数量相关不能超过9999.999");
            if (priceFlag) return this.$message.warning("价格不能超过99999.99");
            let testSave = false;
            testSave = tableList.every(v => {
              if (v.goodsName) {
                return true;
              } else {
                return false;
              }
            });
            let length = 0;
            let lengthPrice = 0;
            tableList.map(table => {
              // if (table.goodsNum === 0) {
              if (table.giveGoodsNum + table.goodsNum <= 0) {
                length = length + 1;
              }
              if (table.price <= 0) {
                lengthPrice = lengthPrice + 1;
              }
            });
            if (testSave) {
              if (length > 0) {
                this.$message({
                  message: "存在数量为0的商品，不能进行保存/审核！",
                  type: "warning"
                });
              } else {
                if (lengthPrice > 0) {
                  this.$confirm("存在进价为0的商品,是否继续保存/审核?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }).then(() => {
                    this.saveData(headParam, e, searchParam);
                  });
                } else {
                  this.saveData(headParam, e, searchParam);
                }
              }
            }
          }
        }
      },
      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm("是否确认审核?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPost(
                    api.purchase.order + "/audit",
                    searchParam
                  ),
                  e
                );
                // this.$message({message: "审核成功！", type: "info"})
              })
              .catch(() =>
                this.$message({message: "审核取消！", type: "info"})
              );
          } else {
            this.$confirm("是否确认保存?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPut(api.purchase.order, searchParam),
                  e
                );
                // this.$message({message: "保存成功！", type: "info"})
              })
              .catch(() =>
                this.$message({message: "保存取消！", type: "info"})
              );
          }
        } else {
          this.$confirm("是否确认保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.handleRequest(
                this.$axios.fetchPost(api.purchase.order, searchParam),
                e
              );
              // this.$message({message: "保存成功！", type: "info"})
            })
            .catch(() => this.$message({message: "保存取消！", type: "info"}));
        }
      },

      handleRequest(param, e) {
        const loading = this.$loading({
          lock: true,
          text: "提交中，请稍候...",
          background: "rgba(225, 225, 225, 0.8)"
        });
        param
          .then(data => {
            if (data.code === 200) {
              if (e === 3) {
                this.$notify({
                  type: "success",
                  title: "审核操作",
                  message: "成功",
                  showClose: false
                });
                // this.$message({message: '审核成功！', type: 'success'});
                this.$router.push({path: "/purchase/order"});
              } else {
                this.$notify({
                  type: "success",
                  title: "保存操作",
                  message: "成功",
                  showClose: false
                });
                // this.$message({message: '保存成功！', type: 'success'});
                this.dialogShow = false;
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.reviewerStatus = data.data.reviewerStatus;
              }
            } else {
              if (e === 3) {
                this.$notify({
                  type: "error",
                  title: "审核操作",
                  message: "失败",
                  showClose: false
                });
                // this.$message({message: '审核失败！' + data.code + ':' + data.errorMsg, type: 'error'});
              } else {
                this.$notify({
                  type: "error",
                  title: "保存失操作",
                  message: "失败",
                  showClose: false
                });
                // this.$message({message: '保存失败！' + data.code + ':' + data.errorMsg, type: 'error'});
              }
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
            loading.close();
          })
          .finally(() => {
            loading.close();
          });
      },
      warehouseChange(data) {
        if (this.isClearTableData) {
          this.$refs["listOperation"].clearTableData();
        } else {
          this.isClearTableData = true;
        }
        this.supplierInfo.warehouseId = data.warehouseId;
        this.isSelectWarehouse = false;
      },
      queryGoodsByBarCode(param, index) {
        let paramMapper = this.$utils.deepClone(this.otherParam);
        paramMapper.barCode = param;
        if (this.otherParam.storeId === -1) {
          paramMapper.relateType = 10;
        } else {
          paramMapper.relateType = 20;
        }
        paramMapper.statusList.push(30, 40);
        // this.otherParam.barCode = param;
        this.$axios
          .fetchPost(api.warehouse.queryGoodsByBarCode, paramMapper)
          .then(data => {
            if (data.code === 200) {
              if (data.data) {
                if (data.data.goodsStatus === 30) {
                  this.$message({
                    message: "该商品已停购，禁止操作！",
                    type: "warning"
                  });
                  this.$refs["listOperation"].setColumnData([], index);
                } else if (data.data.goodsStatus === 40) {
                  this.$message({
                    message: "该商品已淘汰，禁止操作！",
                    type: "warning"
                  });
                  this.$refs["listOperation"].setColumnData([], index);
                } else {
                  data.data.salesAmount = (0.0).toFixed(2); // 销售金额
                  data.data.goodsNum = (0.0).toFixed(3); // 数量
                  data.data.giveGoodsNum = (0.0).toFixed(3); // 赠送数量
                  data.data.price = data.data.buyPrice;
                  data.data.totalPrice = (0.0).toFixed(2);
                  data.data.remarks = null;
                  this.$refs["listOperation"].setColumnData(data.data, index);
                  this.currentTableList = this.$refs[
                    "listOperation"
                    ].getTabelData();
                }
              } else {
                this.$message({message: "无对应商品！", type: "warning"});
                this.$refs["listOperation"].setColumnData([], index);
              }
            } else {
              this.$message({message: "请求失败！", type: "error"});
            }
          });
        this.otherParam.barCode = null;
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios
            .fetchPost(api.purchase.templateDown + "?&downType=10")
            .then(data => {
              if (data.code === 200) {
                const elink = document.createElement("a");
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: "导出操作",
                  message: "成功",
                  showClose: false
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: "导出操作",
                  message: "失败",
                  showClose: false
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            });
        }
      },
      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.importShow = true;
            } else {
              this.$message.warning("请选择仓库");
            }
          } else {
            this.$message.warning("请选择供应商");
          }
        }
      },
      // 导入数据
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.$utils.uploadFile(file => {
                this.$nextTick(() => {
                  this.$refs["importTemplate"].currentStep = 1;
                });
                this.loading = true;
                let formData = new FormData();
                formData.append("multipartFile", file);
                formData.append("supplierId", tableData.supplierId);
                formData.append("warehouseId", tableData.warehouseId);
                formData.append("businessType", 10);
                this.$refs["listOperation"].clearTableData();
                const loading = this.$loading({
                  lock: true,
                  text: "提交中，请稍候...",
                  background: "rgba(225, 225, 225, 0.8)"
                });
                this.$axios
                  .fetchPostGoodsExport(api.purchase.purchaseImport, formData)
                  .then(data => {
                    this.$nextTick(() => {
                      this.$refs["importTemplate"].currentStep = 2;
                    });
                    if (data.code === 200) {
                      this.importShow = false;
                      // 为表格赋值
                      if (data.data.pcGoodsMapMVOList) {
                        data.data.pcGoodsMapMVOList.map(item => {
                          item.id = item.goodsId;
                          item.salesAmount = (
                            item.retailPrice * item.goodsNum
                          ).toFixed(2);
                          if (!item.price) {
                            item.price = item.buyPrice;
                          }
                          item.totalPrice = (item.price * item.goodsNum).toFixed(
                            2
                          );
                        });
                        this.currentTableList = data.data.pcGoodsMapMVOList;
                        this.$refs["listOperation"].addMoreRow(
                          data.data.pcGoodsMapMVOList,
                          0
                        );
                      }
                      if (data.data.errorBatchId) {
                        this.exportErrorData(data.data.errorBatchId);
                      }
                    } else {
                      this.$refs["importTemplate"].currentStep = 3;
                      if (data.errorMsg) {
                        this.$message({message: data.errorMsg, type: "error"});
                      } else {
                        this.$notify({
                          type: "error",
                          title: "导入操作",
                          message: "失败",
                          showClose: false
                        });
                        // this.$message({message: '导入异常', type: 'error'});
                      }
                    }
                  })
                  .catch(err => {
                    this.$refs["importTemplate"].currentStep = 0;
                  })
                  .finally(() => {
                    this.loading = false;
                    loading.close();
                  });
              });
            } else {
              this.$message({message: "请选择仓库！", type: "warning"});
            }
          } else {
            this.$message({message: "请选择供应商！", type: "warning"});
          }
        }
      },
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: "正在导出...",
          background: "rgba(225, 225, 225, 0.8)"
        });
        this.$axios
          .PostBlob(api.system.exportError + "?batchId=" + id, "")
          .then(res => {
            if (res.status === 200) {
              const fileName =
                "采购商品错误数据" + "_" + this.$utils.getDateTime() + ".xlsx";
              let blob = new Blob([res.data]);
              let downloadElement = document.createElement("a");
              let href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = fileName; //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              // this.$message.success("导出成功,文件名称:" + fileName);
              this.$notify({
                type: "success",
                title: "导出操作",
                message: "成功!文件名称:" + fileName,
                showClose: false
              });
            } else {
              this.$notify({
                type: "error",
                title: "导出操作",
                message: "失败",
                showClose: false
              });
              // this.$message.error("导出失败,请稍后再试");
            }
          })
          .catch(() => {
            this.$message.warning("当前导出数据为空或超出10000条。");
          })
          .finally(() => {
            loading.close();
          });
      }
    }
  };
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/purchase/OrderAdd.vue